<template>
  <div>
    <label :for="idInner" v-if="libelleLong">
      <div class="d-flex mb-2">
        <div v-html="libelleLong"></div>
        <span class="ml-1 red--text" v-if="!optionel">*</span>
      </div>
    </label>

    <infobulle v-if="descriptionPopup" :descriptionPopup="descriptionPopup"> </infobulle>
    <template v-if="typeDeChamp === 'TELEPHONE'">
      <v-phone-input
        :id="idInner"
        :style="{ width: largeurMaxEnPx, display: 'flex', alignItems: 'center' }"
        v-bind="$attrs"
        :value="value"
        :hint="innerFacade"
        :persistent-hint="!!innerFacade"
        :rules="textFieldRules"
        @input="handleInput"
        @blur="$emit('blur', $event)"
        :label="label"
        :dense="isDense"
        :outlined="isOutlined"
        ref="phoneInput"
        validate-on-blur
        default-country="CA"
      ></v-phone-input>
    </template>
    <template v-else>
      <v-text-field
        :id="idInner"
        :style="{ width: largeurMaxEnPx }"
        v-bind="$attrs"
        :value="value"
        :hint="innerFacade"
        :persistent-hint="!!innerFacade"
        :rules="textFieldRules"
        @input="handleInput"
        @blur="$emit('blur', $event)"
        :label="label"
        v-facade="innerFacade ? innerFacade : ''"
        :dense="isDense"
        :outlined="isOutlined"
        ref="textField"
        validate-on-blur
      ></v-text-field>
    </template>
  </div>
</template>

<script>
import ChampBase from "./mixins/ChampBase";
export default {
  mixins: [ChampBase],
  methods: {
    handleInput(event) {
      this.$emit("input", event);
    },
  },
  computed: {
    textFieldRules() {
      if(this.optionel && !this.value) {
        return [];
      }

      if (!this.optionel && !this.value) {
        return [this.champObligatoireMessage];
      }

      if (this.regExValidation) {
        return this.regExRules;
      }

      return this.optionalRules;
    },

    regExRules() {
      return [(v) => this.regex.test(v) || this.regExValidationMessage];
    },

    regex() {
      return this.value ? new RegExp(this.regExValidation) : new RegExp("");
    },

    innerFacade() {
      if (this.masque) {
        return this.masque;
      }
      return "";
    },
  },
};
</script>

<style>
.v-phone-input {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.v-phone-input .v-phone-input__dropdown {
  min-width: 100px; /* Ajuste la largeur minimale du sélecteur de pays */
}

.v-phone-input .v-phone-input__input {
  flex: 1; /* Laisse le champ téléphonique occuper tout l'espace restant */
}
</style>
